import React from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import VerifierDroitsComponent from '../VerifierDroits/VerifierDroitsComponent';

const RouteSecurisee = ({ path, render, droits = [], droitsInterdits, exact }) => {
    return (
        <VerifierDroitsComponent droits={droits} droitsInterdits={droitsInterdits}>
            <Route path={path} render={render} exact={exact} />
        </VerifierDroitsComponent>
    );
};

RouteSecurisee.propTypes = {
    path: PropTypes.string.isRequired,
    render: PropTypes.any.isRequired,
    exact: PropTypes.bool,
    droits: PropTypes.array.isRequired,
    droitsInterdits: PropTypes.array,
};

RouteSecurisee.defaultProps = {
    exact: false,
};

export default RouteSecurisee;
